// src/components/PublicRoute.tsx
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/auth-context";

interface PublicRouteProps {
  redirectPath?: string;
}

const PublicRoute = ({ redirectPath = "/" }: PublicRouteProps) => {
  const { token } = useAuth(); // Usa el contexto para verificar la autenticación

  // Si el usuario está autenticado, redirige a la ruta especificada
  if (token) {
    return <Navigate to={redirectPath} replace />;
  }

  // Si no está autenticado, permite el acceso a la ruta pública
  return <Outlet />;
};

export default PublicRoute;
